<template>
  <div class="wizard-container">
    <div class="wizard-card">
      <b-card no-body>
        <div>
          <h2 class="mb-0">
            <strong>{{ styleStore.storeInfo?.name }} Voucher</strong>
          </h2>
          <!-- <p class="mb-0">
            You can buy a {{ styleStore.storeInfo?.name }} voucher for an amount of your choosing...
          </p> -->
        </div>
        <hr>
        <b-card-body>
          <keep-alive>
            <component
              :is="currentStepComponent"
              :key="formStore.currentStepIndex"
              :form-data="formStore.formData"
              @next="formStore.nextStep"
              @back="formStore.prevStep"
              @update-details="formStore.updateFormData"
              @complete="handleComplete"
            />
          </keep-alive>
          <b-alert
            v-if="formStore.error"
            variant="danger"
            show
          >
            {{ formStore.error }}
          </b-alert>
          <b-spinner
            v-if="formStore.loading"
            label="Loading..."
          />
        </b-card-body>
      </b-card>
    </div>

    <div class="how-it-works-card">
      <HowItWorks />
    </div>
  </div>
</template>

<script>
import { useFormStore } from "../stores/formStore";
import { useStyleStore } from "../stores/styleStore";
import Step1Value from "./Step1Value.vue";
import Step2Delivery from "./Step2Delivery.vue";
import Step3Details from "./Step3Details.vue";
import Step4Purchaser from "./Step4Purchaser.vue";
import Step5Summary from "./Step5Summary.vue";
import HowItWorks from "./HowItWorks.vue";

const steps = [
  Step1Value,      // Value
  Step2Delivery,   // Delivery
  Step3Details,    // Details
  Step4Purchaser,  // Purchaser
  Step5Summary,    // Summary
];

// const stepNames = [
//   'Value',
//   'Delivery',
//   'Details',
//   'Purchaser',
//   'Summary'
// ];

export default {
  components: {
    HowItWorks,
  },
  data() {
    return {
      formStore: useFormStore(),
      styleStore: useStyleStore(),
      ignoreNextPopState: false, // Prevents infinite loops
    };
  },
  computed: {
    currentStepComponent() {
      return steps[this.formStore.currentStepIndex];
    },
  },
  watch: {
    "formStore.currentStepIndex": {
      immediate: true,
      handler(newIndex) {
        this.updateHistoryState(newIndex);
      },
    },
  },
  beforeUnmount() {
    window.removeEventListener('popstate', this.handlePopState);
  },
  mounted() {
    // Initialize history state
    history.replaceState({ step: this.formStore.currentStepIndex }, '');
    window.addEventListener('popstate', this.handlePopState);
  },
  methods: {
    updateHistoryState(stepIndex) {
      if (history.state?.step !== stepIndex) {
        this.ignoreNextPopState = true;
        history.pushState({ step: stepIndex }, '');
      }
    },
    
    handlePopState(event) {
      // if (this.ignoreNextPopState) {
      //   this.ignoreNextPopState = false;
      //   return;
      // }

      // const newStep = this.formStore.currentStepIndex - 1
      // if (newStep !== this.formStore.currentStepIndex && newStep != -1) {
      //   debugger
      //   this.formStore.setStepDirectly(newStep);
      // }else{
      //   this.formStore.setStepDirectly(this.formStore.currentStepIndex + 1);
      // }
       const state = event.state;
        if (state && typeof state.step === 'number') {
          this.formStore.setStepDirectly(state.step);
        } else {
          console.warn("No state or invalid state in popstate event");
        }
    },
    
    async handleComplete() {
      try {
        await this.formStore.completePurchase();
      } catch (error) {
        console.error("Purchase failed:", error);
      }
    },
  },
};
</script>

<style scoped>
.wizard-container {
  display: flex;
  gap: 70px;
  max-width: 100%;
  margin: 0 auto;
  box-shadow: -1px -1px 12px 2px rgba(0, 0, 0, 0.1),
    0 4px 6px -4px rgba(0, 0, 0, 0.1);
  padding: 45px;
  border-radius: 20px;
}

.wizard-card {
  flex: 2;
  min-width: 0;
}
.wizard-card .card {
  border: none !important;
  border-radius: 0.25rem;
}

.how-it-works-card {
  flex: 1;
  min-width: 0;
}

@media (max-width: 768px) {
  .wizard-container {
    flex-direction: column;
    padding: 15px;
  }

  .wizard-card,
  .how-it-works-card {
    width: 100%;
  }
}

.b-card {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border: none;
}

.b-card-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #eee;
}
</style>
<style>
.btn-light {
  background-color: #d8d8d8 !important;
}
</style>
